import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function LoginPage() {
  const [step, setStep] = useState("credentials");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [code, setCode] = useState("");
  const [userId, setUserId] = useState(null);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const { login, verifyCode, resendCode } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const data = await login(email, password);
      setUserId(data.user_id);
      setStep("code");
      setSuccess("Code envoy&eacute; par email !");
    } catch (err) {
      setError(err.response && err.response.data ? err.response.data.error : "Erreur de connexion");
    } finally {
      setLoading(false);
    }
  };

  const handleVerify = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const data = await verifyCode(userId, code);
      if (data.user.role === "admin") navigate("/admin");
      else if (data.user.role === "merchant") navigate("/merchant");
      else navigate("/scan");
    } catch (err) {
      setError(err.response && err.response.data ? err.response.data.error : "Code invalide");
    } finally {
      setLoading(false);
    }
  };

  const handleResend = async () => {
    setError(""); setSuccess("");
    try {
      await resendCode(userId);
      setSuccess("Nouveau code envoy&eacute; !");
    } catch {
      setError("Erreur lors du renvoi du code");
    }
  };

  const fillDemo = (role) => {
    const accounts = {
      admin: { email: "admin@comoticket.km", password: "Cm@Admin#2024!" },
      merchant: { email: "ali@comoticket.km", password: "Cm@Ali#2024!" },
      controller: { email: "controleur@comoticket.km", password: "Cm@Ctrl#2024!" },
    };
    setEmail(accounts[role].email);
    setPassword(accounts[role].password);
  };

  return (
    <div className="login-page">
      <div className="login-left">
        <div className="login-card">
          <div className="login-brand">Como<span>Ticket</span></div>
          <div className="login-tagline">Billetterie simple pour tous</div>

          {step === "credentials" ? (
            <>
              <div className="login-title">Connexion</div>
              <div className="login-sub">Connectez-vous &agrave; votre espace</div>
              {error && <div className="error-msg"><span dangerouslySetInnerHTML={{__html: "&#9888; " + error}} /></div>}
              <form onSubmit={handleSubmit}>
                <div className="form-group">
                  <label className="form-label">Email</label>
                  <input type="email" className="form-input" placeholder="exemple@comoticket.km" value={email} onChange={(e) => setEmail(e.target.value)} required />
                </div>
                <div className="form-group">
                  <label className="form-label">Mot de passe</label>
                  <div style={{position:"relative"}}>
                    <input type={showPassword ? "text" : "password"} className="form-input" placeholder="********" value={password} onChange={(e) => setPassword(e.target.value)} style={{paddingRight:44}} required />
                    <button type="button" onClick={() => setShowPassword(!showPassword)} style={{position:"absolute",right:12,top:"50%",transform:"translateY(-50%)",background:"none",border:"none",cursor:"pointer",fontSize:16,padding:4}} dangerouslySetInnerHTML={{__html: showPassword ? "&#128584;" : "&#128065;"}} />
                  </div>
                </div>
                <button type="submit" className="btn btn-primary btn-lg btn-full" disabled={loading}>
                  {loading ? "Connexion..." : "Se connecter"}
                </button>
              </form>
              <div style={{ marginTop: 24, paddingTop: 20, borderTop: "1px solid var(--gray-200)" }}>
                <div style={{ fontSize: 12, color: "var(--gray-400)", marginBottom: 10, textAlign: "center" }}>Comptes de demonstration</div>
                <div style={{ display: "flex", gap: 8 }}>
                  <button className="btn btn-ghost" style={{ flex: 1, fontSize: 12 }} onClick={() => fillDemo("admin")}>Admin</button>
                  <button className="btn btn-ghost" style={{ flex: 1, fontSize: 12 }} onClick={() => fillDemo("merchant")}>Commer&ccedil;ant</button>
                  <button className="btn btn-ghost" style={{ flex: 1, fontSize: 12 }} onClick={() => fillDemo("controller")}>Contr&ocirc;leur</button>
                </div>
              </div>
            </>
          ) : (
            <>
              <div className="login-title">Verification</div>
              <div className="login-sub">Entrez le code re&ccedil;u par email</div>
              {error && <div className="error-msg"><span dangerouslySetInnerHTML={{__html: "&#9888; " + error}} /></div>}
              {success && <div style={{ background: "var(--green-pale)", color: "#065f46", borderRadius: 8, padding: "10px 14px", fontSize: 13, marginBottom: 16 }}><span dangerouslySetInnerHTML={{__html: "&#10003; " + success}} /></div>}
              <form onSubmit={handleVerify}>
                <div className="form-group">
                  <label className="form-label">Code &agrave; 6 chiffres</label>
                  <input
                    type="text"
                    className="form-input"
                    placeholder="123456"
                    value={code}
                    onChange={(e) => setCode(e.target.value.replace(/[^0-9]/g, "").slice(0, 6))}
                    style={{ fontSize: 24, letterSpacing: 8, textAlign: "center", fontWeight: 700 }}
                    maxLength={6}
                    required
                    autoFocus
                  />
                </div>
                <button type="submit" className="btn btn-primary btn-lg btn-full" disabled={loading || code.length !== 6}>
                  {loading ? "Verification..." : "Verifier le code"}
                </button>
              </form>
              <div style={{ display: "flex", justifyContent: "space-between", marginTop: 16 }}>
                <button onClick={() => { setStep("credentials"); setCode(""); setError(""); setSuccess(""); }} style={{ background: "none", border: "none", color: "var(--gray-400)", fontSize: 13, cursor: "pointer" }}>
                  &larr; Retour
                </button>
                <button onClick={handleResend} style={{ background: "none", border: "none", color: "var(--blue)", fontSize: 13, cursor: "pointer", fontWeight: 600 }}>
                  Renvoyer le code
                </button>
              </div>
            </>
          )}
        </div>
      </div>
      <div className="login-right">
        <div className="login-hero-title">La billetterie<br />adapt&eacute;e aux <span>Comores</span></div>
        <div className="login-hero-desc">Vente de billets en cash via vos commer&ccedil;ants de confiance. QR codes s&eacute;curis&eacute;s, stock en temps r&eacute;el, z&eacute;ro double-vente.</div>
        <div className="feature-list">
          <div className="feature-item"><span className="feature-icon">&#127915;</span><span className="feature-text">Billets &eacute;lectroniques avec QR code unique</span></div>
          <div className="feature-item"><span className="feature-icon">&#128176;</span><span className="feature-text">Paiement cash via commer&ccedil;ants physiques</span></div>
          <div className="feature-item"><span className="feature-icon">&#128202;</span><span className="feature-text">Suivi des ventes et commissions en temps r&eacute;el</span></div>
          <div className="feature-item"><span className="feature-icon">&#10003;</span><span className="feature-text">Validation &agrave; l'entr&eacute;e avec scan QR code</span></div>
        </div>
      </div>
    </div>
  );
}